//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'vant';
import Header from '../header/header.vue'
import Footer from '../footer/footer.vue'
import quoLoginModule from "@/pages/product/quoLoginModule"
import companyBindeForm from "@/pages/modules/companyBindeForm"
import createAndBindCompanyForm from "@/pages/modules/createAndBindCompanyForm"
import { commonTool } from '@/util/tool'
import userBindConfirm from "@/pages/modules/userBindConfirm"
export default {
  name: 'appDetail',
  components: {
    Footer,
    Header,
    quoLoginModule,
    companyBindeForm,
    createAndBindCompanyForm,
    userBindConfirm
  },
  data () {
    return {
      userInfo: this.$store.getters.getUserInfo,
      currentAppInfo: {},
      sloganArray: []
    }
  },
  computed:{

  },
  methods:{
    handleBtnUseFreeClicked () {
      if (this.currentAppInfo.id == 'APP_XMPC') {
        if (this.userInfo && this.userInfo.id) {
          console.log('this.userInfo ===>', this.userInfo)
          this.fnCheckUserBindFactory(() => {
            this.$refs.companyBindeForm.showForm(this.currentAppInfo)
          })
        } else {
          this.$refs.quoLoginModule.showLogin()
        }
      } else {
        Toast('暂未开通')
      }
    },
    fnCheckUserBindFactory (callBack) {
      var user = {
        userPhone: this.userInfo.userPhone
      }
      var param = {
        in: JSON.stringify(user),
        appId: this.currentAppInfo.id
      }
      this.$store.dispatch('company/checkUserBindFactory', param)
        .then(res => {
          console.log('fnCheckUserBindFactory res ===>', res)
          if (res.data && res.data.retCode == 1) {
            var user = JSON.parse(res.data.obj)
            if (user && user.userRoleRels && user.userRoleRels.length > 0) {
              this.$refs.userBindConfirm.showConfirm(
                () => {
                  this.$router.push({path: '/quickEnterIn', query: {'appId': this.currentAppInfo.id}})
                },
                () => {
                  callBack()
                }
              )
            } else {
              callBack()
            }
          } else {
            callBack()
          }
        }).catch(err => {
          console.log('fnCheckUserBindFactory err===>', err)
          Toast(err)
        })
    },
    //跳转到平台首页
    fnGoToHomePage(e){
      this.fnStopBub(e);
      this.$router.push({path: '/home'})
    },
    handleLognSucccess (userInfo) {
      this.userInfo = userInfo
      this.$refs.header.fnSetUserInfo(this.userInfo)
      this.handleBtnUseFreeClicked()
    },
    handleBtnAppPubMainClicked (e) {
      this.fnStopBub(e);
      this.$router.push({path: '/appPubMain'})
    },
    createAndBindCompanyInfo (appInfo) {
      this.$refs.createAndBindCompanyForm.showForm(appInfo)
    },
    handleBtnGotoApp () {
      window.open(this.currentAppInfo.loginUrl)
    }
  },
  mounted () {
    let appJson = localStorage.getItem("currentAppInfo")
    if (appJson && appJson != '') {
      this.currentAppInfo = JSON.parse(appJson)
      this.sloganArray = []
      if (this.currentAppInfo.slogans) {
        let slogans = this.currentAppInfo.slogans.split(';')
        slogans.forEach(slogan => {
          if (slogan) {
            this.sloganArray.push(slogan)
          }
        })
      }
      console.log('this.currentAppInfo ===>', this.currentAppInfo)
    }
  },
  created () {

  }
}



// WEBPACK FOOTER //
// ./src/pages/appPub/appDetail.vue